import React, { useState, useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { SaveCancel } from "../../uiControls/saveCancel";
import * as utils from "../../common/utils";
import { TableWithStickyHeaderToAddNew } from "../../uiControls/tableWithStickyHeaderToAddNew";

const facilityColumns = [
  {
    label: "",
    keyField: "appUnit",
    dataField: "appUnit",
    minWidth: "20px",
    maxWidth: "20px",
    fieldType: "number",
  },
  {
    label: "Name",
    keyField: "appUnit",
    dataField: "name",
    fieldType: "label",
  },
  {
    label: "Support Email",
    keyField: "appUnit",
    dataField: "supportEmail",
    fieldType: "email",
    maxWidth: "200px",
  },
  {
    label: "Functional Area",
    keyField: "appUnit",
    dataField: "functionalAreaKey",
    fieldType: "dropdown",
    listSource: "functionalAreas",
    maxWidth: "130px",
  },
  {
    label: "Data Source",
    keyField: "appUnit",
    dataField: "datasourceKey",
    fieldType: "dropdown",
    listSource: "datasources",
    maxWidth: "130px",
  },
  {
    label: "Time Zone",
    keyField: "appUnit",
    dataField: "timezoneKey",
    fieldType: "dropdown",
    listSource: "timezones",
    maxWidth: "130px",
  },
];

export const FacilityAdd = (props) => {
  const { setUpdateOpen, functionalAreas, datasources, timezones } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateFacility } = useHttpRequests();
  const [selectedRows, setSelectedRows] = useState([]);

  const getUrl = (params) => {
    return "Facilities?" + params;
  };

  const cancelFacilityHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setUpdateOpen(false);
  };

  const validateFacilityDetails = () => {
    var errorSummary = "";

    if (selectedRows.some((item) => item["name"] === "")) {
      errorSummary +=
        "Facility name required. Please contact administrator. \n";
    }

    if (selectedRows.some((item) => item["houseCode"] === "")) {
      errorSummary += "House code required. Please contact administrator. \n";
    }

    if (
      selectedRows.some(
        (item) =>
          item["supportEmail"] !== "" &&
          !utils.validateEmail(item["supportEmail"])
      )
    ) {
      errorSummary += "Invalid email. \n";
    }

    if (selectedRows.some((item) => !item["functionalAreaKey"])) {
      errorSummary += "Select functional area. \n";
    }

    if (selectedRows.some((item) => !item["datasourceKey"])) {
      errorSummary += "Select data source. \n";
    }

    if (selectedRows.some((item) => !item["timezoneKey"])) {
      errorSummary += "Select time zone. \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({
          type: "error",
          message: "Selected record needs review like- \n" + errorSummary,
        })
      );
    } else {
      const dataObj = selectedRows?.map((obj) => {
        return {
          facilityKey: obj["facilityKey"],
          timezoneKey: obj["timezoneKey"],
          supportEmail: obj["supportEmail"],
          functionalAreaKey: obj["functionalAreaKey"],
          datasourceKey: obj["datasourceKey"],
          appUnit: obj["appUnit"],
          isTestFacility: obj["isTestFacility"] ?? false,
          active: true,
        };
      });
      const getUpdateFacilityResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          resObj["validationErrors"]?.length > 0
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Facilities added successfully!",
          })
        );
        setTimeout(() => {
          cancelFacilityHandler();
        }, 2000);
      };
      updateFacility(
        { url: "Facilities/Create/Multi", body: dataObj },
        getUpdateFacilityResponse
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "5px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              overflow: "auto",
            }}
          >
            <TableWithStickyHeaderToAddNew
              title="ESM Facilities"
              pagging={true}
              columns={facilityColumns}
              url={getUrl}
              sourceObj="facilities"
              list={{
                functionalAreas: functionalAreas,
                datasources: datasources,
                timezones: timezones,
              }}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
            <SaveCancel
              cancelCall={() => cancelFacilityHandler()}
              saveCall={() => validateFacilityDetails()}
            />
          </div>
        </div>
      </Box>
    </>
  );
};
